import { iRule } from "./models";

export const defaultRule: iRule = {
  field: "adName",
  operator: "is",
  value: "",
  routeTo: "STANDARD_ROUTING",
  routingConfig: {},
};
